import { render, staticRenderFns } from "./RegionPopup.vue?vue&type=template&id=c947d3b8&scoped=true&"
import script from "./RegionPopup.vue?vue&type=script&lang=js&"
export * from "./RegionPopup.vue?vue&type=script&lang=js&"
import style0 from "./RegionPopup.vue?vue&type=style&index=0&id=c947d3b8&scoped=true&lang=css&"
import style1 from "./RegionPopup.vue?vue&type=style&index=1&id=c947d3b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c947d3b8",
  null
  
)

export default component.exports